import {useSelector} from 'react-redux'
import {useOfferCheckContext} from 'components/Accommodation/Rooms/OfferCheckContext'
import {getEngagedOfferHotelId} from 'modules/priceAlertPrompt/slice'
import {getCheckInDayDistance} from 'modules/search/selectors'

import {useBrandCapabilities} from '@vio/core/src/_web/brand/hooks/useBrandCapabilities'
import {getIsGhaChecker} from '@vio/core/src/rateChecker/selectors'

import {PROMPT_MIN_LEAD_DAYS} from './constants'

export const usePriceAlertPromptEligibility = (
  hotelId: string | undefined
): boolean => {
  const checkInDayDistance = useSelector(getCheckInDayDistance)
  const engagedOfferHotelId = useSelector(getEngagedOfferHotelId)
  const {isUserInitiatedCheckPending} = useOfferCheckContext()
  const {retention} = useBrandCapabilities()
  const isGhaChecker = useSelector(getIsGhaChecker)

  const hasEngagedWithThisHotel =
    Boolean(hotelId) && engagedOfferHotelId === hotelId

  return (
    Boolean(retention.hasPriceWatch) &&
    !isGhaChecker &&
    checkInDayDistance >= PROMPT_MIN_LEAD_DAYS &&
    !hasEngagedWithThisHotel &&
    !isUserInitiatedCheckPending
  )
}
